(function () {
  const el = document.getElementById('location-data');
  if (!el) return;

  var data;
  try { data = JSON.parse(el.textContent); }
  catch (e) { console.error('location-page: bad JSON', e); return; }

  var DAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  var LABELS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function fmt12(t) {
    if (!t) return '';
    var parts = t.split(':');
    var h = parseInt(parts[0], 10);
    var m = parseInt(parts[1], 10);
    var period = h >= 12 ? 'PM' : 'AM';
    var h12 = h % 12 || 12;
    return m === 0 ? (h12 + ' ' + period) : (h12 + ':' + pad(m) + ' ' + period);
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function fmtPhone(p) {
    if (!p) return '';
    var d = p.replace(/\D/g, '');
    if (d.length === 10) return '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6);
    return p;
  }

  function parseHours(val) {
    if (!val) return {};
    if (typeof val === 'object') return val;
    try { return JSON.parse(val); } catch (e) { return {}; }
  }

  function hoursTable(hoursObj) {
    var rows = DAYS.map(function (day, i) {
      var h = hoursObj[day];
      var time = (h && h.open) ? fmt12(h.open) + ' – ' + fmt12(h.close) : 'Closed';
      return '<tr><td class="loc-day">' + LABELS[i] + '</td><td class="loc-time">' + time + '</td></tr>';
    }).join('');
    return '<table class="loc-hours-table"><tbody>' + rows + '</tbody></table>';
  }

  function esc(str) {
    return (str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function haversine(lat1, lng1, lat2, lng2) {
    var R = 3958.8;
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLng = (lng2 - lng1) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  /* ── map ─────────────────────────────────────────────── */

  var mapEl = document.getElementById('loc-map');
  if (mapEl && data.mapsUrl) {
    mapEl.innerHTML =
      '<iframe src="' + esc(data.mapsUrl) + '"' +
      ' allowfullscreen loading="lazy"' +
      ' referrerpolicy="no-referrer-when-downgrade"' +
      ' title="' + esc(data.name) + ' map"></iframe>';
  }

  /* ── info panel ──────────────────────────────────────── */

  var infoEl = document.getElementById('loc-info');
  if (!infoEl) return;

  var hours = parseHours(data.hours);
  var petHours = parseHours(data.petHours);
  var hasPet = DAYS.some(function (d) { return petHours[d] && petHours[d].open; });

  var addr2Line = data.address2 ? ', ' + esc(data.address2) : '';
  var phone = fmtPhone(data.phone);
  var rawPhone = (data.phone || '').replace(/\D/g, '');

  var groomingModal = document.getElementById('loc-mytime-grooming-modal');
  var boardingModal = document.getElementById('loc-mytime-boarding-modal');

  var groomingCta = groomingModal
    ? '<button type="button" class="loc-btn loc-btn-grooming" data-modal="loc-mytime-grooming-modal">Book Grooming</button>'
    : '';

  var bathCta = boardingModal
    ? '<button type="button" class="loc-btn loc-btn-bath" data-modal="loc-mytime-boarding-modal">Book Boarding</button>'
    : '';

  infoEl.innerHTML =
    '<h1 class="loc-name">' + esc(data.name) + '</h1>' +

    '<p class="loc-address">' +
    esc(data.address1) + addr2Line + ', ' +
    esc(data.city) + ', ' + esc(data.province) + ' ' + esc(data.zip) +
    '</p>' +

    (phone
      ? '<p class="loc-phone"><a href="tel:+1' + rawPhone + '">' + esc(phone) + '</a></p>'
      : '') +

    '<p class="loc-hours-heading">Store Hours:</p>' +
    hoursTable(hours) +

    (hasPet
      ? '<p class="loc-hours-heading">Pet Wash Hours:</p>' + hoursTable(petHours)
      : '') +

    (groomingCta || bathCta
      ? '<hr class="loc-divider"><div class="loc-cta-buttons">' + groomingCta + bathCta + '</div>'
      : '');

  // Buttons are injected after ModalComponent.connectedCallback runs, so aria-controls
  // won't be auto-wired. Wire clicks manually using data-modal attribute.
  infoEl.querySelectorAll('[data-modal]').forEach(function (btn) {
    var modal = document.getElementById(btn.dataset.modal);
    if (modal && typeof modal.show === 'function') {
      btn.addEventListener('click', function () { modal.show(btn); });
    }
  });

  document.getElementById('loc-page').removeAttribute('aria-busy');

  /* ── nearby locations ────────────────────────────────── */

  var allEl = document.getElementById('all-locations-data');
  var nearbyEl = document.getElementById('loc-nearby-list');
  if (!allEl || !nearbyEl) return;

  var allLocs;
  try { allLocs = JSON.parse(allEl.textContent); }
  catch (e) { nearbyEl.innerHTML = '<p>No Other Locations Nearby</p>'; return; }

  var lat = parseFloat(data.latitude);
  var lng = parseFloat(data.longitude);

  if (!lat || !lng) { nearbyEl.innerHTML = '<p>No Other Locations Nearby</p>'; return; }

  var nearby = allLocs
    .filter(function (loc) { return loc.lat && loc.lng; })
    .map(function (loc) {
      return {
        handle: loc.handle,
        name: loc.name,
        addr: [loc.address1, loc.city, loc.province].filter(Boolean).join(', '),
        dist: haversine(lat, lng, parseFloat(loc.lat), parseFloat(loc.lng))
      };
    })
    .sort(function (a, b) { return a.dist - b.dist; })
    .slice(0, 4);

  if (!nearby.length) { nearbyEl.innerHTML = '<p>No Other Locations Nearby</p>'; return; }

  nearbyEl.innerHTML = '<div class="loc-nearby-list">' +
    nearby.map(function (loc) {
      return '<a href="/pages/location/' + esc(loc.handle) + '" class="loc-nearby-card">' +
        '<span class="loc-nearby-name">' + esc(loc.name) + '</span>' +
        '<span class="loc-nearby-addr">' + esc(loc.addr) + '</span>' +
        '<span class="loc-nearby-dist">' + loc.dist.toFixed(1) + ' mi away</span>' +
        '</a>';
    }).join('') +
    '</div>';
})();
